import type { FindTotpSecretResponse, TotpRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { stringValueObject } from '@contexts/shared/domain';

export type GenerateTotpSecretInput = {
	token: string;
};

export type GenerateTotpSecretUseCase = UseCase<GenerateTotpSecretInput, FindTotpSecretResponse>;

export function generateTotpSecretBuilder(
	totpRepository: TotpRepository
): GenerateTotpSecretUseCase {
	return async function generateTotpSecret(
		input: GenerateTotpSecretInput
	): Promise<FindTotpSecretResponse> {
		const token = stringValueObject().validate('token', input.token);

		return totpRepository.generateSecret(token);
	};
}
